<template>
  <v-edit-dialog
    lazy
    large
    cancel-text="Отмена"
    save-text="Ок"
    @cancel="closeDialog"
    @open="openDialog"
    @save="save"
  >
    <v-chip
      text-color="white"
      class="pointer"
      label
      small
      :color="getLabelColor(label, editableValue ? 1 : 0)"
    >
      {{ getLabelTitle(label, editableValue ? 1 : 0) }}
    </v-chip>
    <app-tiny-reference
      slot="input"
      v-model="editableValue"
      class="mx-2"
      :custom-items="getCustomItems(label)"
      :disabled="disabled"
    />
  </v-edit-dialog>
</template>
<script>
import labels from "./lables.js";
export default {
  props: ["value", "item", "index", "column", "disabled"],
  data() {
    return {
      editableValue: 0,
    };
  },
  computed: {
    selectedValue() {
      return this.$store.getters["oldVersionWarehouseDetails/selectedValue"];
    },
    labels() {
      return labels;
    },
    label() {
      if (
        this.column.name === "packingMethodIn" ||
        this.column.name === "packingMethodOut"
      ) {
        return "packingMethod";
      } else {
        return this.column.name;
      }
    },
  },
  watch: {
    value: {
      handler(value) {
        if (value && typeof value === "boolean") {
          this.editableValue = value ? 1 : 0;
        } else {
          this.editableValue = value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getLabelColor(name, value, groupName) {
      let currentLabel = this.labels[name];

      if (groupName) {
        currentLabel = this.labels[groupName].value[name];
      }
      if (currentLabel) {
        const label = currentLabel.variants.find((i) => {
          return i.id === value;
        });
        return label && label.color ? label.color : "grey";
      }
      return "grey";
    },
    getLabelTitle(name, value, groupName) {
      let currentLabel = this.labels[name];
      if (groupName) {
        currentLabel = this.labels[groupName].value[name];
      }

      if (currentLabel) {
        const label = currentLabel.variants.find((i) => {
          return i.id === value;
        });
        return label ? label.title : currentLabel.variants[0].title;
      }
      return "";
    },
    getCustomItems(name, groupName) {
      let currentLabel = this.labels[name];
      if (groupName) {
        currentLabel = this.labels[groupName].value[name];
      }

      if (currentLabel) {
        return currentLabel.variants.map((i) => {
          return { value: i.id, text: i.title };
        });
      }
      return [];
    },
    openDialog() {
      this.$store.dispatch("oldVersionWarehouseDetails/openDialog", {
        value: this.editableValue,
        rowIndex: this.index,
      });
    },
    closeDialog() {
      this.editableValue = this.selectedValue;
      this.$store.dispatch("oldVersionWarehouseDetails/closeDialog");
    },
    async save() {
      if (this.label === "isFullBath" || this.label === "packingMethod") {
        if (Object.prototype.hasOwnProperty.call(this.item, this.column.name)) {
          this.item[this.column.name] = this.editableValue;
        }
        await this.$store.dispatch(
          "oldVersionWarehouseDetails/save",
          this.item,
        );
      } else {
        await this.$store.dispatch(
          "oldVersionWarehouseDetails/saveShippingLabel",
          {
            shippingId: this.item.Shipping.Id,
            label: {
              name: this.label,
              value: this.editableValue,
            },
          },
        );
      }
    },
  },
};
</script>
